import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useOnStateChanged } from '@/lib/hooks';
import authentication from '@/lib/authentication';

const ProtectedWrapper = ({ component: Component }: { component: React.ReactElement }) => {
  const [hasUserState, setHasUserState] = useState(false);
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);

  useOnStateChanged();

  useEffect(() => {
    void (async () => {
      try {
        setUserIsLoggedIn(await authentication.userIsLoggedIn());
      } catch (error) {
        setUserIsLoggedIn(false);
      } finally {
        setHasUserState(true);
      }
    })();
  }, []);

  return hasUserState ? (
    userIsLoggedIn ? (
      Component
    ) : (
      <Navigate
        replace
        to="/"
      />
    )
  ) : null;
};

export { ProtectedWrapper };
